import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  TextField,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Collapse,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from '@mui/icons-material';
import { Formik, Form } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router";
import { MuiTelInput } from "mui-tel-input";
import AuthAPI, { SignInRequest } from "../../../apis/AuthAPI";
import SmsDogrulamaSaveAPI, { SmsDogrulamaSaveRequest } from "../../../apis/OB/SaveApi/SmsDogrulamaSaveAPI";
import Recaptcha from "../../Recaptcha";
import SmsKoduKontrolAPI, { SmsDogrulamaKontrolRequest } from "../../../apis/OB/SaveApi/SmsKoduKontrolAPI";
import SifremiUnuttumAPI, { SmsDogrulamaRequest } from "../../../apis/OB/SaveApi/SifremiUnuttumAPI";
import EmailAPI, { EmailRequest } from "../../../apis/EmailAPI";
import ResponsiveTabs from "../Tabbar";
import { toast } from 'react-toastify';

const TcTelefonKullaniciVarMi = (props: any) => {
  const [isError, setIsError] = useState(false);
  const [goSmsControl, setGoSmsControl] = useState(false);
  const [seconds, setSeconds] = useState(300);
  const [isActive, setIsActive] = useState(false);
  const [userState,setUserState]=useState<any>(null);
  const [smsCode, setSmsCode] = useState("");
  const [errorContent, setErrorContent] = useState("");
  const [refNo, setRefNo] = useState<any>(undefined);
  const [recaptchaPassed, setRecaptchaPassed] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const navigate = useNavigate();
  const recaptchaTokenRef: any = useRef();
  const [successMessage, setSuccessMessage] = useState("");
  const [open, setOpen] = useState(true);
  const [channel, setChannel] = useState<'sms' | 'email'>('sms');
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);


  const tabItems = props.vergiNo == null ? props.tcKimlikNo == null ? [
    { title: "T.C. Kimlik No" },
    { title: "Vergi No" }
  ] : [
    { title: "T.C. Kimlik No" },

  ] : [

    { title: "Vergi No" }
  ];

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  useEffect(() => {
    if (goSmsControl) {
      setIsActive(true);
    }
  }, [goSmsControl]);
  // yeni ekle
  const [initialValues, setInitialValues] = useState({
    tcKimlikNo: "",
    vergiNo: ""
  });
  const [readOnly, setReadOnly] = useState(false);

  useEffect(() => {
    if (props.tcKimlikNo || props.vergiNo) {
      setInitialValues({
        tcKimlikNo: props.tcKimlikNo || "",
        vergiNo: props.vergiNo || ""
      });
      setReadOnly(true);
      setIsUserLoggedIn(true);

      // Hangi alan gelmişse o tab'ı seç
      if (props.vergiNo) {
        setSelectedTab(1);
      } else if (props.tcKimlikNo) {
        setSelectedTab(0);
      }

    } else {
      // props yoksa normal davranış
      setInitialValues({ tcKimlikNo: "", vergiNo: "" });
      setReadOnly(false);
      setIsUserLoggedIn(false);
    }
  }, [props.tcKimlikNo, props.vergiNo]);


  function maskPhoneNumber(phoneNumber: string): string {
    // Telefon numarasındaki boşlukları temizle
    let cleanedNumber = phoneNumber.replace(/\s+/g, "");

    // Eğer numara '+90' ile başlamıyorsa ve 10 haneli ise, başına '+90' ekleyelim
    if (cleanedNumber.length === 10 && /^[0-9]{10}$/.test(cleanedNumber)) {
      cleanedNumber = `+90${cleanedNumber}`;
    }

    // Telefon numarasının uzunluğu doğrulandıktan sonra maskeleme işlemi yapılır
    if (cleanedNumber.length === 13 && cleanedNumber.startsWith("+90")) {
      const countryCode = cleanedNumber.substring(0, 3); // "+90"
      const firstTwoDigits = cleanedNumber.substring(3, 5); // "53"
      const lastTwoDigits = cleanedNumber.substring(cleanedNumber.length - 2); // "45"

      // Maskeleme
      return `${countryCode} ${firstTwoDigits}* *** ** ${lastTwoDigits}`;
    }

    // Eğer numara formatı uymazsa, olduğu gibi döndür
    return phoneNumber;
  }

  useEffect(() => {
    let interval: any = null;
    if (isActive && seconds > 0) {
      interval = setInterval(() => {
        setSeconds((seconds) => seconds - 1);
      }, 1000);
    } else if (seconds === 0) {
      setIsActive(false);
    }
    return () => clearInterval(interval);
  }, [isActive, seconds]);

  const restartTimer = () => {
    setSeconds(60);
    setIsActive(true);
  };

  const handleRecaptchaChange = (value: boolean) => {
    setRecaptchaPassed(value);
  };

  // Dinamik validation schema
  const getValidationSchema = () => {
    if (selectedTab === 0) {
      // TC Kimlik No tab'ı için validation
      return yup.object({
        tcKimlikNo: yup
          .string()
          .required("T.C. Kimlik Numarası zorunludur")
          .length(11, "T.C. Kimlik Numarası 11 haneli olmalıdır."),
        vergiNo: yup.string().notRequired(),
      });
    } else {
      // Vergi No tab'ı için validation
      return yup.object({
        tcKimlikNo: yup.string().notRequired(),
        vergiNo: yup
          .string()
          .required("Vergi Numarası zorunludur")
          .min(10, "Vergi Numarası en az 10 haneli olmalıdır."),
      });
    }
  };
  const handleClose = () => {
    setOpen(false);
    if (props.onClose) {
      props.onClose();
    } else {
      navigate(-1);
    }
  };

  return (
    <Dialog open={true} onClose={handleClose}>
      <Formik
        key={selectedTab} // Tab değiştiğinde form'u resetle

        initialValues={initialValues}        
        enableReinitialize={true}
        validationSchema={getValidationSchema()}
        onSubmit={async (values, { setSubmitting, setFieldValue }) => {
          const recaptchaToken = await recaptchaTokenRef.current?.handleSubmit();

          if (recaptchaToken) {
            // Seçilen tab'a göre request oluştur
            let tcKimlikNo = selectedTab === 0 ? values.tcKimlikNo : undefined;
            let vergiNo = selectedTab === 1 ? values.vergiNo : undefined;

            let request = new SmsDogrulamaRequest(
              undefined,
              tcKimlikNo,
              vergiNo,
              undefined,
              undefined,
              recaptchaToken,
              false
            );
            request.isResend = false;

            // Props'a seçilen değeri gönder
            if (selectedTab === 0) {
              props.tcKimlikNoSet(values.tcKimlikNo);
              props.vergiNoSet && props.vergiNoSet(undefined);
              console.log("tc no: ", values.tcKimlikNo);
            } else {
              props.tcKimlikNoSet(undefined); // TC Kimlik No boş gönder
              props.vergiNoSet && props.vergiNoSet(values.vergiNo);
              console.log("vergi no: ", values.vergiNo);
            }

            try {
              const res = await SifremiUnuttumAPI.SendSms(request);
              console.log("res.data ", res.data);

              if (res.data.sonuc === 0) {
                setRefNo(res.data.referenceNumber);
                setUserState({ cepTelefon: res.data.telefonNumarasi });
                setChannel('sms');
                setGoSmsControl(true);
              } else {
                setErrorContent(res.data.sonucAciklama);
                setIsError(true);
                setRecaptchaPassed(false);
                recaptchaTokenRef.current.reset();
                setTimeout(() => {
                  setIsError(false);
                  setErrorContent("");
                }, 4000);
              }
            } catch (err: any) {
              const serverMessage = err.response?.data?.message || err.message;
              setErrorContent(serverMessage || "Bir hata oluştu. Lütfen tekrar deneyin.");
              setIsError(true);
              setRecaptchaPassed(false);
              recaptchaTokenRef.current.reset();
              setTimeout(() => {
                setIsError(false);
                setErrorContent("");
              }, 4000);
            } finally {
              setSubmitting(false);
            }
          } else {
            setIsError(true);
            setSubmitting(false);
            setTimeout(() => {
              setIsError(false);
              setErrorContent("");
            }, 4000);
          }
        }}
      >
        {({ values, handleChange, handleBlur, handleSubmit, errors, touched, isSubmitting, setFieldValue, resetForm }) => {
          const handleSmsConfirm = () => {
            if (smsCode.length < 6) {
              setErrorContent("SMS kodu 6 haneli olmalıdır.");
              setIsError(true);
              setTimeout(() => {
                setIsError(false);
                setErrorContent("");
              }, 4000);
            } else {
              // Seçilen tab'a göre request oluştur
              let tcKimlikNo = selectedTab === 0 ? values.tcKimlikNo : undefined;
              let vergiNo = selectedTab === 1 ? values.vergiNo : undefined;

              const isMailFlag = channel === 'email';

              let request = new SmsDogrulamaKontrolRequest(
                tcKimlikNo || "",
                refNo,
                smsCode,
                vergiNo,
                undefined,
                undefined,
                isMailFlag,
                isUserLoggedIn
              );

              SmsKoduKontrolAPI.saveSmsDogrulamaKontrolSave(request)
                .then((res) => {
                  if (res.data[0].sonuc === 0) {
                    props.smsControlledSet(true);
                  } else {
                    setErrorContent(res.data[0].sonucAciklama);
                    setIsError(true);
                    setTimeout(() => {
                      setIsError(false);
                      setErrorContent("");
                    }, 4000);
                  }
                })
                .catch((err) => {
                  setErrorContent("Bir hata oluştu. Lütfen tekrar deneyin.");
                  setIsError(true);
                  setTimeout(() => {
                    setIsError(false);
                    setErrorContent("");
                  }, 4000);
                });
            }
          };
          return (
            <Form onSubmit={handleSubmit}>
              {!goSmsControl ? (
                <>
                  <DialogTitle>
                    Telefon Kontrolü
                    <IconButton
                      aria-label="close"
                      onClick={handleClose}
                      sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent className="pt-3">
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                      {/* Tabbar */}
                      <ResponsiveTabs
                        items={tabItems}
                        value={selectedTab}
                        onChange={handleTabChange}
                        spreadWidth={true}
                      />

                      {/* TC Kimlik No Input - Sadece TC tab'ında görünür */}
                      {selectedTab === 0 && (
                        <TextField
                          size="small"
                          fullWidth
                          name="tcKimlikNo"
                          label="T.C. Kimlik No"
                          inputProps={{
                            maxLength: 11
                          }}
                          variant="outlined"
                          value={values.tcKimlikNo}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.tcKimlikNo && Boolean(errors.tcKimlikNo)}
                          helperText={touched.tcKimlikNo && errors.tcKimlikNo}
                          disabled={readOnly}
                        />
                      )}

                      {/* Vergi No Input - Sadece Vergi tab'ında görünür */}
                      {selectedTab === 1 && (
                        <TextField
                          size="small"
                          fullWidth
                          name="vergiNo"
                          label="Vergi No"
                          inputProps={{
                            maxLength: 10
                          }}
                          variant="outlined"
                          value={values.vergiNo}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.vergiNo && Boolean(errors.vergiNo)}
                          helperText={touched.vergiNo && errors.vergiNo}
                          disabled={readOnly}
                        />
                      )}

                      <Collapse in={isError}>
                        <Alert severity="error">{errorContent}</Alert>
                      </Collapse>
                      <Recaptcha ref={recaptchaTokenRef} changeHandleRecaptcha={handleRecaptchaChange} />
                    </Box>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      type="submit"
                      color="primary"
                    >
                      SMS Gönder
                    </Button>
                    <Button
                      color="secondary"
                      onClick={async () => {
                        // E-Posta ile doğrulama kodu gönder
                        const recaptchaToken = await recaptchaTokenRef.current?.handleSubmit();
                        if (!recaptchaToken) {
                          setIsError(true);
                          setErrorContent("Lütfen reCAPTCHA doğrulamasını tamamlayın.");
                          setTimeout(() => setIsError(false), 3000);
                          return;
                        }
                        let tcKimlikNo = selectedTab === 0 ? values.tcKimlikNo : undefined;
                        let vergiNo = selectedTab === 1 ? values.vergiNo : undefined;

                        if (selectedTab === 0) {
                          if (!tcKimlikNo || tcKimlikNo.length !== 11) {
                            setIsError(true);
                            setErrorContent("T.C. Kimlik Numarası 11 haneli olmalıdır.");
                            setTimeout(() => setIsError(false), 3000);
                            return;
                          }
                        } else {
                          if (!vergiNo || vergiNo.length < 10) {
                            setIsError(true);
                            setErrorContent("Vergi Numarası en az 10 haneli olmalıdır.");
                            setTimeout(() => setIsError(false), 3000);
                            return;
                          }
                        }
                        try {
                          const emailRequest = new EmailRequest(
                            undefined,
                            tcKimlikNo,
                            recaptchaToken,
                            vergiNo,
                            isUserLoggedIn // isLogin
                          );

                          const res = await EmailAPI.mailGonder(emailRequest);
                          if (res.sonuc == 0) {
                            setRefNo(res.referenceNumber);
                            setChannel('email');
                            setGoSmsControl(true);
                            toast.success('Doğrulama kodu email adresinize gönderilmiştir.');

                            // Props'u güncelle
                            if (selectedTab === 0) {
                              props.tcKimlikNoSet(values.tcKimlikNo);
                              props.vergiNoSet && props.vergiNoSet(undefined);
                            } else {
                              props.tcKimlikNoSet(undefined);
                              props.vergiNoSet && props.vergiNoSet(values.vergiNo);
                            }

                          } else {
                            setErrorContent(res.sonucAciklama || "E-posta gönderilemedi");
                            setIsError(true);
                            setTimeout(() => setIsError(false), 4000);
                          }
                        } catch (err: any) {
                          const serverMessage = err.response?.data?.message || err.message;
                          setErrorContent(serverMessage || "E-posta gönderilirken hata oluştu. Lütfen tekrar deneyin.");
                          setIsError(true);
                          setTimeout(() => setIsError(false), 4000);
                        }
                      }}
                    >
                      Mail Gönder
                    </Button>
                  </DialogActions>
                </>
              ) : (
                <>
                  <DialogTitle>
                    {channel === 'sms' ? 'Sms Kontrolü' : 'E-posta Kontrolü'}
                    <IconButton
                      aria-label="close"
                      onClick={handleClose}
                      sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                      {isActive ? (
                        <Typography>
                          {channel === 'sms'
                            ? `${(userState.cepTelefon)} Telefonunuza SMS kodu gönderildi. Lütfen kodu giriniz.`
                            : `E-posta adresinize doğrulama kodu gönderildi. Lütfen kodu giriniz.`}
                        </Typography>
                      ) : (
                        <Typography>Kodu girmediniz. Tekrar göndermeyi deneyin.</Typography>
                      )}
                      <Collapse in={isError}>
                        <Alert severity="error">{errorContent}</Alert>
                      </Collapse>
                      {isActive && (
                        <TextField
                          size="small"
                          fullWidth
                          name="smsCode"
                          label="Doğrulama Kodu"
                          variant="outlined"
                          value={smsCode}
                          onChange={(e) => setSmsCode(e.target.value.substring(0, 6))}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              handleSmsConfirm();
                            }
                          }}
                        />
                      )}
                      <Typography variant="h6">{seconds}</Typography>
                    </Box>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={async () => {
                        setSmsCode("");
                        // Seçilen tab'a göre request oluştur
                        let tcKimlikNo = selectedTab === 0 ? values.tcKimlikNo : undefined;
                        let vergiNo = selectedTab === 1 ? values.vergiNo : undefined;

                        // SMS için
                        if (channel === "sms") {
                          let request = new SmsDogrulamaRequest(
                            userState?.cepTelefon,
                            tcKimlikNo,
                            vergiNo,
                            undefined,
                            undefined,
                            undefined,
                            false
                          );
                          request.isResend = true;

                          try {
                            const res = await SifremiUnuttumAPI.SendSms(request);
                            if (res.data?.sonuc === 0) {
                              setRefNo(res.data.referenceNumber);
                              setGoSmsControl(true);
                            } else {
                              setErrorContent(res.data?.sonucAciklama || "Tekrar gönderilemedi.");
                              setIsError(true);
                              setTimeout(() => {
                                setIsError(false);
                                setErrorContent("");
                              }, 4000);
                            }
                          } catch (err: any) {
                            setErrorContent("Bir hata oluştu. Lütfen tekrar deneyin.");
                            setIsError(true);
                            setTimeout(() => {
                              setIsError(false);
                              setErrorContent("");
                            }, 4000);
                          }
                        }
                        // E-posta için
                        else {
                          try {
                            const emailRequest = new EmailRequest(
                              undefined,
                              tcKimlikNo,
                              undefined,
                              vergiNo,
                              isUserLoggedIn  // isMail
                            );

                            const res = await EmailAPI.mailGonder(emailRequest);
                            if (res?.sonuc === 0) {
                              setRefNo(res.referenceNumber);
                              setGoSmsControl(true);
                              toast.success("Doğrulama kodu e-postanıza yeniden gönderildi.");
                            } else {
                              setErrorContent(res?.sonucAciklama || "E-posta tekrar gönderilemedi.");
                              setIsError(true);
                              setTimeout(() => {
                                setIsError(false);
                                setErrorContent("");
                              }, 4000);
                            }
                          } catch (err: any) {
                            const serverMessage = err.response?.data?.message || err.message;
                            setErrorContent(serverMessage || "E-posta gönderilirken hata oluştu. Lütfen tekrar deneyin.");
                            setIsError(true);
                            setTimeout(() => {
                              setIsError(false);
                              setErrorContent("");
                            }, 4000);
                          }
                        }

                        restartTimer();
                      }}
                      disabled={isActive}
                    >
                      {channel === 'sms' ? 'Tekrar Gönder' : 'Kodu Yeniden Gönder'}
                    </Button>

                    <Button onClick={handleSmsConfirm}>Tamam</Button>
                  </DialogActions>
                </>
              )}
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
};

export default TcTelefonKullaniciVarMi;